var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0266 4.54998C14.9474 4.23359 14.7862 3.94369 14.5591 3.70958C14.332 3.47547 14.0471 3.30544 13.7333 3.21665C12.5866 2.93665 7.99997 2.93665 7.99997 2.93665C7.99997 2.93665 3.41331 2.93665 2.26664 3.24331C1.95281 3.3321 1.66796 3.50214 1.44087 3.73625C1.21378 3.97036 1.0525 4.26025 0.973308 4.57665C0.763451 5.74035 0.660798 6.92085 0.666641 8.10331C0.65916 9.29468 0.761819 10.4842 0.973308 11.6566C1.06061 11.9632 1.22551 12.2421 1.45207 12.4663C1.67863 12.6905 1.95919 12.8525 2.26664 12.9366C3.41331 13.2433 7.99997 13.2433 7.99997 13.2433C7.99997 13.2433 12.5866 13.2433 13.7333 12.9366C14.0471 12.8479 14.332 12.6778 14.5591 12.4437C14.7862 12.2096 14.9474 11.9197 15.0266 11.6033C15.2349 10.4484 15.3375 9.27687 15.3333 8.10331C15.3408 6.91195 15.2381 5.72244 15.0266 4.54998V4.54998Z",
    stroke: "#E5194D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 10.2833L10.3333 8.10334L6.5 5.92334V10.2833Z",
    stroke: "#E5194D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.27002)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.1d072e34ac5c0338d809f4fbdc366c28.svg";
export { ForwardRef as ReactComponent };